<template>
    <div v-if="row['id']" class="d-flex flex-column justify-content-start">
        <b-button @click="onClick" variant="link" class="text-nowrap text-left p-0">
            <span>№{{ row['id'] }}</span>
        </b-button>
        <small class="d-flex text-secondary flex-nowrap nowrap">
            <span v-if="row.status === 1"><b-icon icon="circle-fill" variant="warning" class="mr-2"/></span>
            <span v-if="row.status === 2"><b-icon icon="circle-fill" variant="success" class="mr-2"/></span>
            <span v-if="row.status === 3"><b-icon icon="circle-fill" variant="danger" class="mr-2"/></span>
            <span>{{ row['status_object']['label'] }}</span>
        </small>
    </div>
    <span v-else>&mdash;</span>
</template>

<script>
    export default {
        name: "RaidNumberStatusCell",
        props: {
            row: { },
            modalName: { type: String },
        },
        methods: {
            onClick() {
                this.$emit('object-modal-triggered', this.modalName, this.row['id'])
            }
        }
    }
</script>

<style scoped>

</style>